var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"0px","padding":"0px"}},[_c('span',{staticStyle:{"width":"200px","height":"200px","font-size":"24px","position":"fixed","top":"0px","left":"0px","right":"0px","bottom":"0px","margin":"auto"}},[_vm._v("\n        支付宝登录页面跳转中。。。。。。\n    ")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.sHtmlText)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3e98e9c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/alipaylogin/alipayauth.vue
// module id = null
// module chunks = 